<script>
export default {
  props: {
    value: {
      type: Number,
      validator: value => value > -1,
      default: 0,
    },
  },

  data() {
    return {
      slotNodes: [],
    }
  },

  computed: {
    nextSlotIndex() {
      return (this.value + 1) % this.slotNodes.length
    },
  },

  mounted() {
    this.slotNodes = Object.values(this.$slots)
  },

  methods: {
    slotUpdated(e) {
      this.$emit(`slotUpdated`, e, this.nextSlotIndex)
    },
  },
}
</script>
